
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-970368ac&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./exhibitionBrandList.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./exhibitionBrandList.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-970368ac!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./exhibitionBrandList.vue"),
  /* scopeId */
  "data-v-970368ac",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/addOrEditActive/exhibitionBrandList.vue
// module id = 1491
// module chunks = 3